<template>
  <div>
    <div v-if="isLoading">{{ $t('auth.validatingAccount') }}</div>
  </div>
</template>

<script>
import { VALIDATE_ACCOUNT } from '@/store/modules/user/types'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'

export default {
  name: 'ValidateAccount',
  data: () => ({
    isLoading: true,
    success: false
  }),
  mounted: async function() {
    const code = this.$route.query.code

    const [error, response] = await this.$store.dispatch(VALIDATE_ACCOUNT, {
      code
    })

    if (error || response.data.error) {
      this.success = false
      this.isLoading = false
      this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/internal-error') })
      this.$router.push({ name: 'login' })
    } else {
      this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('success.validated') })
      this.$router.push('/')
    }
  }
}
</script>
